import React from 'react';

import { Span, Box } from 'src/lib/StyledComponents';
import theme from 'src/lib/theme';

const Label = props => (
	<Box>
		<Span
			fontSize={theme.fontSizes[0]}
			fontWeight="bold"
			borderRadius="10px"
			padding="7px 8px 6px 8px"
			whiteSpace="nowrap"
			marginRight="1px"
			marginLeft="1px"
			{...props.labelStyle}
		>
			{props.children}
		</Span>
	</Box>
);

export default Label;



// WEBPACK FOOTER //
// ./src/components/Label/index.js